import { useFormMethods } from '../../../../../helpers/formManager';
import { useEvent } from '../../../../../hooks/useEvent';

export const useSyncByIntervalTime = (getFn) => {
  const { getValues, setValue } = useFormMethods();

  return useEvent((duration) => {
    const { fieldName, selectedIds, controller, onTimeChange } = getFn();

    const currentTime = getValues(fieldName);

    if (!currentTime) {
      return;
    }

    if (!duration && currentTime) {
      setValue(fieldName, null);
      onTimeChange(currentTime.context.id, null);
      return;
    }

    const nextTime = controller.syncTime({
      duration,
      prevTime: currentTime,
      selectedIds,
    });

    setValue(fieldName, nextTime);
    onTimeChange(currentTime.context.id, nextTime?.context?.id ?? null);
  });
};
